<!-- 弹出式选择器 -->
<template>
<el-dialog
  :visible.sync="visible"
  :append-to-body="true"
  width="90%"
  top="1vh"
  :title="select.searchslottitle||'' + (select.multiple ? ' (多选)' : ' (单选)')"
  :close-on-click-modal="false"
  @closed="closeClick"
  v-dialogdrag
>
  <div class="selector_template">
    <div class="topSearch">
      <mform v-if="searchOption.column.length>0" ref="searchForm" v-model="query" :option="searchOption" @submit="searchChange" @reset="searchReset"></mform>
    </div>
    <div id="printDiv">
      <ux-grid v-bind="$attrs" ref="selectTable"
        :height='tableHeightFn()'
        :stripe="allOption.stripe"
        size="mini"
        v-loading="loading"
        @sort-change="sortChange"
        @row-click="rowClick"
        @select="seleChange"
        :checkboxConfig="{showHeader:select.multiple}"
      >
        <ux-table-column v-if="select.multiple" type="checkbox" width="40" align="center" fixed="left"></ux-table-column>
        <template v-for="(item) in allOption.column">
          <ux-table-column
            v-if="hidColumnData.indexOf(item.prop) === -1"
            :align="item.align || 'center'"
            :sortable="item.sortable"
            :show-overflow="true"
            :key="item.id"
            resizable
            :field="item.prop"
            :title="item.label"
            :fixed="(item.fixed?'left':false)"
            :min-width="item.width || 80">
            <template slot-scope="scope">
              <slot v-if="item.dicData.length>0" :name="item.prop" v-bind='{scope,item}'>
                <span v-if="item.urlType=='2'||item.urlType=='7'" :style='{color:filterArr(item.dicData,"value",scope.row[item.prop],"color")}'
                  :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)"
                  v-text="filterArr(item.dicData,'value',scope.row[item.prop],'label')"></span>
                <i v-else :style='{color:filterArr(item.dicData,"value",scope.row[item.prop],"color")}'
                  :class='filterArr(item.dicData,"value",scope.row[item.prop],"icon")'></i>
              </slot>
              <slot v-else>
                <span :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)">{{scope.row[`$${item.prop}`]||scope.row[item.prop]}}</span>
              </slot>
            </template>
          </ux-table-column>
        </template>
      </ux-grid>
    </div>
    <div class="ux-page">
      <footer>
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="page.currentPage"
          :page-sizes="page.pageSizes"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </footer>
    </div>
    <div class="determine">
      <div style="text-aligin:left;"><p v-html="allOption.bottomTip">123</p></div>
      <el-button type="primary" v-for="(item,index) in JSON.parse(allOption.bottomButton||'[]')||[]" :key="index" size="small" style="margin-right:10px" @click="urlClick(item)">{{item.name}}</el-button>
      <el-button v-if="select.multiple" type="primary" size="small" style="margin-right:10px" @click="determine">确定</el-button>
      <el-button type="danger" size="small"  @click="closeClick">取消</el-button>
    </div>
  </div>
</el-dialog>
</template>
<script>
import {mapGetters} from "vuex";
import {SelectorConfigure,getShow,get} from "@/api/table/table";
import mform from '@/components/table/selector/mformSelect';
import {parseParams,getObjType,urlToObj,strByReg} from "@/util/util";
import crypto from "@/util/crypto";
export default {
components: {
  mform,
},
props:{select:Object,visible:Boolean},
// searchslotId:String,
// searchslotkey:Object,
// searchslotType:String,
// filterWhere:String,
// excludeid:String,
// colname:String,
// multiple:Boolean,
// search:Object},
data() {
  return {
    loading:true,
    extendedProp:{},  // 扩展字段
    page: {
      pageSize: 20,
      currentPage: 1,
      total: 0,
      pageSizes:[5, 10, 20, 50, 100, 200, 500, 1000]
    },
    query: {}, //查询
    option:{
      dataType:"string",
      stripe:true,
    },
    selector:false, //选择器
    finderExProp:{},
    column:[],
    searchList:[],  //搜索配置list
    hidColumnData:[],  //显示/隐藏的prop list
    sortOrder:"", // 记录排序状态
    searchOption:{
      labelWidth:0,
      menuSpan:4,
      enter:true,
      noLabel:true,
      submitText: '搜索',
      submitIcon: 'el-icon-search',
      column:[],
    }
  };
},
//监听属性 类似于data概念
computed: {
  ...mapGetters(["userInfo"]),
  allOption:function(){
    return {
      ...this.option,
      ...this.finderExProp,
      column:this.column,
    }
  },
},
//监控data中的数据变化
watch: {
  visible:function(ne){
    if(ne){
      if (this.column.length==0) {
        this.configureData(this.select);
      }else{
        this.onLoad();
      }
    }
  },
},
//方法集合
methods: {
  // 链接点击事件
  async urlClick(item,row){
    if(item.method){
      this.$emit(item.method); return
    }
    if(!item.linkType) return;
    let queryObj=item.linkParam?this.urlFn(item.linkParam,row):{};
    let runId=item.linkOpid?this.userInfo.runId:this.$route.query.runId;
    switch (item.linkMethod) {
      case "1":  //  详情
        this.$router.push({
          path:item.linkPath,
          query:{runId:runId,...queryObj},
        })
        break;
      case "2":  //  列表
        this.$router.push({
          path:item.linkPath,
          query:{runId:runId,...queryObj},
        })
        break;
      case "9":  //  外部
        this.$router.push({
          path:"/myiframe/urlPath",
          query:{
            src:parseParams(item.linkPath,{runId:runId,...queryObj})
          },
        })
        break;
      case "10":  //  触发事件
        console.log(item.linkPath+"Click");
        this.$parent.$parent.$parent.$parent[item.linkPath+"Click"](item,this.value);
        break;
      default:
        break;
    }
  },
  urlFn(str,data){
    let arr = str.split("&");
    let obj={};
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      obj[element.split("=")[0]]=element.split("=")[1].indexOf("{")===-1?element.split("=")[1]:data[element.split("=")[1].replace(/{|}/g,"")]
    }
    return obj;
  },
  // 加载table
  onLoad() {
    this.loading = true;
    getShow(this.page.currentPage, this.page.pageSize,this.$route.query.runId, {
      colname:this.select.colname,
      filterWhere:this.select.filterWhere,
      excludeid:this.select.excludeid,
      obj:{...this.query,...this.select.search},
      finderId:this.select.searchslotId,
      extendTreeType:0,
    }).then(res => {
      const data = res.data.data;
      this.page.total = data.total;
      this.select.formateResMd5 && this.select.formateResMd5.forEach(item => {
          data.records.forEach(it => {
            it[item] = crypto.decryptAES(it[item],crypto.aesKey);
          })
        })
      this.$refs.selectTable.reloadData(data.records);
      this.loading = false;
      this.selectionClear();
    });
  },
  currentChange(currentPage) {
    this.page.currentPage = currentPage;
    this.onLoad();
  },
  sizeChange(pageSize) {
    this.page.pageSize = pageSize;
    this.page.currentPage = 1;
    this.onLoad();
  },
  refreshChange() {
    this.onLoad();
  },
  searchReset() {
    this.query = {};
    this.onLoad();
  },
  searchChange(params,done) {
    this.query = Object.assign(this.query, params);
    for (const key in this.query) {
      if (Array.isArray(this.query[key])&key!=="highSearch") {
        this.query[key]=this.query[key].toString();
      }
    }
    this.page.currentPage = 1;
    this.onLoad();
    done();
  },
  selectionChange() {
    let list=this.$refs.selectTable.getCheckboxRecords();
    // console.log(list);
    let obj=this.deepClone(this.select.searchslotkey);
    for (const key in obj) {
      const objKey=this.select.searchslotkey[key];
      let arr=[];
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        arr.push(element[objKey])
      }
      obj[key]=arr;
    }
    this.$emit("listenEvent",obj);
  },
  selectionClear() {
    this.$refs.selectTable.clearSelection();
  },
  async sortChange(val){
    !!val.order && this.sortOrder == val.order? this.$refs.plxTable.clearSort():this.$refs.plxTable.sort(val.prop,this.sortOrder);
    this.sort={[`${val.order}s`]:val.prop};
    await this.onLoad();
    this.sortOrder = val.order;
    this.$refs.plxTable.sort(val.prop,val.order);
  },
  rowClick(row, column, cell, event){
    this.$refs.selectTable.toggleRowSelection([{row: row}])
    if(!this.select.multiple){
      this.selectionChange();
    }
  },
  seleChange(selection,row){
    if(!this.select.multiple){
      this.selectionChange();
    }
  },
  // 点击确定按钮
  determine(){
    this.selectionChange();
  },
  // 关闭
  closeClick(){
    this.$emit('update:visible', false);
  },
  async configureData(select){
    // console.log(select);
    if(!this.$route.query.runId) return;
    try {
      let searchList=[];
      let [configList,dataList] = await Promise.all([
        SelectorConfigure({id:select.searchslotId,runId:this.$route.query.runId}),
        getShow(1, this.page.pageSize,this.$route.query.runId, {
          colname:select.colname||"",
          filterWhere:select.filterWhere||"",
          excludeid:select.excludeid||"",
          obj:{...this.query,...select.search},
          finderId:select.searchslotId,
          extendTreeType:0,
        })
      ])
      const data=configList.data.data;
      let list=data.list;
      // if(data.standardButton){
      //   for (let i = 0; i < data.standardButton.length; i++) {
      //     const button = data.standardButton[i];
      //     this.allOption[button.btnType]=true;
      //   }
      // }
      if(data.finderExProp){
        this.finderExProp=urlToObj(data.finderExProp);
      }
      for (let index = 0; index < list.length; index++) {
        let object=list[index];
        for (const key in object) {
          if (object[key]==="") {
            delete object[key];
          }else if(object[key]==="true"){
            object[key]=true;
          }else if(object[key]==="false"){
            object[key]=false;
          }
        }
        if(object.type==="icon"){  //  icon
          object.iconList=iconList;
        }
        if(object.rules){  //验证
          object.rules=JSON.parse(object.rules);
          if(object.rules[1].pattern===""&&object.rules[0].required==="false"){
            object.rules=[];
          }else if(object.rules[1].pattern===""&&object.rules[0].required!=="false"){
            object.rules.splice(1,1);
            if(object.rules[0].required==="true"){
              object.rules[0].required=true
            }else{
              object.rules[0].required=false
            }
          }else if(object.rules[1].pattern!==""&&object.rules[0].required==="false"){
            object.rules[1].pattern=strByReg(object.rules[1].pattern);
            object.rules.splice(0,1);
          }else{
            object.rules[1].pattern=strByReg(object.rules[1].pattern);
          }
        }
        if (object.dicUrl) object.urlType=object.dicUrl.split("&")[0].replace('type=',"");
        if(object.hide===true){  //  隐藏
          this.hidColumnData.push(object.prop)
        }
        if(!object.dicData){
          object.dicData=[];
        }
        if(object.search){   //搜索配置
          let searchObj={};
          if("checkboxswitchselect".indexOf(object.type)!==-1||object.dicData.length>0){
            searchObj.type="select";
          }else if("associationtextarea".indexOf(object.type)!==-1){
            searchObj.type="input";
          }else if(object.type=="selectDown"||object.type=="treeSelect"){  //下拉翻页
            if(object.selectData){
              object.selectData.selectData=object.selectData.selectData.filter(item=>{return item.hide!="true"}).slice(0,6);
              searchObj.selectData=object.selectData;
              searchObj.type=object.type;
            }
          }else if("datedatetime".indexOf(object.type)!==-1){
            searchObj.type="daterange";
          }else{
            searchObj.type=object.type;
          }
          if(object.searchSpan){   // 搜索宽度
            object.searchSpan=Number(object.searchSpan);
          }
          delete searchObj.rules;
          searchObj.prop=object.prop;
          searchObj.label=object.label;
          searchObj.dicData=object.dicData;
          searchObj.searchslotkey=object.searchslotkey;
          searchObj.searchslotid=object.searchslotid;
          searchObj.finderWhere=object.finderWhere;
          searchObj.codeTable=object.codeTable;
          searchObj.corField=object.corField;
          searchObj.searchslottitle=object.searchslottitle;
          searchObj.selectData=object.selectData;
          searchObj.span=4;
          searchObj.tip=searchObj.label;
          searchList.push(searchObj);
        }
      }
      console.log(searchList);
      // this.searchList=searchList;
      this.$set(this.searchOption,'column',searchList);
      this.column=list;
      // 数据 ↓

      const data1 = dataList.data.data;
      this.select.formateResMd5 && this.select.formateResMd5.forEach(item => {
        data1.records.forEach(it => {
            it[item] = crypto.decryptAES(it[item],crypto.aesKey);
          })
        })
      this.page.total = data1.total;
      this.$refs.selectTable.reloadData(data1.records);
      // this.loading = false;
      this.$nextTick(()=>{
        this.loading=false;
      })
    } catch (err) {
      this.loading=false;
    }
  },
  // 获取表格最大高度
  tableHeightFn(){
    let height=document.getElementById("avue-view");
    if(height){
      if(height.clientHeight>=558){
        return height.clientHeight-208;
      }else{
        return 350
      }
    }
  },
  // 过滤  数组 key 等于的值  return
  filterArr(arr,key,value,re){
    if (!arr) return;
    let array=[];
    if(getObjType(value)!=='string') return;
    for (let index = 0; index < value.split(",").length; index++) {
      const id = value.split(",")[index];
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if(element[key]==id){
          array.push(element[re]);
        }
      }
    }
    return array.join(" | ");
  },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
mounted() {},
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
/deep/ .el-dialog__body{
  padding-top: 0;
}
.selector_template{
  .topSearch{
    /deep/ .el-form-item__label{
      display: none;
    }
    /deep/ .el-button--mini{
      padding: 6px;
    }
    /deep/ .el-form-item--mini.el-form-item{
      margin-bottom: 0px;
    }
  }
  .ux-page{
    margin-top: 14px;
    height:32px;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    // footer{
    //   float: right;
    // }
  }
  /deep/ .elx-table .elx-cell {
    padding-left: 0;
    padding-right: 0;
  }
  /deep/.el-form-item__label {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
  }
  /deep/.el-form-item__content {
    margin-left: 0px !important;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
  }
  /deep/td {
    height: 32px !important;
  }
  /deep/.el-transfer-panel {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;
    background: #FFF;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
  }
}
/deep/.el-transfer-panel__body {
  height: 100% !important;
}
/deep/.el-transfer-panel__list {
  padding-left: 15px !important;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  height: 100% !important;
  overflow: auto;
  box-sizing: border-box;
}
/deep/.el-transfer-panel__item {
  width: 100%;
  padding: 0px;
  height: 30px;
  line-height: 30px;
  display: block!important;
}
/deep/.elx-table .elx-table--empty-content{
  width: 0% !important;
}
.url{
  cursor: pointer;
  color: #2E5AE8;
}
/deep/.elx-table .row--hover {
  background-color: #bfdbe9 !important;
}
</style>
<style>
.elx-table--tooltip-wrapper{
  z-index: 9999 !important;
}
.determine{
  text-align: center;
}
</style>
